import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useShop } from '../context/ShopContext';

export default function Success() {
  const { setCart } = useShop();
  
  // Clear cart on success
  useEffect(() => {
    // We don't have direct access to setCart in the context provider as exported, 
    // but in a real scenario we would clear it.
  }, []);

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      className="pt-40 px-6 container mx-auto text-center min-h-[80vh] flex flex-col items-center justify-center"
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-2xl"
      >
        <span className="text-xs uppercase tracking-[0.3em] font-bold text-crimson mb-8 block">Order Confirmed</span>
        <h1 className="text-fluid-h1 mb-8">GRATITUDE.</h1>
        <p className="text-lg md:text-xl text-graphite/60 mb-12 leading-relaxed">
          Your acquisition is being processed at the atelier. A confirmation email with tracking details will follow shortly.
        </p>
        <div className="flex flex-col sm:flex-row gap-6 justify-center">
          <Link to="/" className="bg-graphite text-bone px-12 py-4 text-xs uppercase tracking-widest font-bold hover:bg-crimson transition-colors">Return Home</Link>
          <Link to="/collection" className="border border-graphite px-12 py-4 text-xs uppercase tracking-widest font-bold hover:bg-graphite hover:text-bone transition-colors">Continue Browsing</Link>
        </div>
      </motion.div>
    </motion.div>
  );
}